import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('glLedgerService', (http, CacheFactory, config) => new LocalCache({
    provider: () => http.get('/ledger'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.ledger,
    cacheName: 'ledger',
  })
);